<template>
  <div>
    <div class="das_top_cont">
      <div class="history_box account_input">
        <div class="accountright_cont_box margin-bottom20">
          <h2 class="history_box-head flex_center_between_box">Data Management</h2>
          <div class="flex_center_between_box">
            <ul class="flex_center Data-Management-ul">
              <li v-for="(item, index) in managementMenu" @click="MenuClick(item)"
                :class="menuActive == item.value ? 'menuActiveColor font18 font_bold' : 'font18'" :key="index">{{ item.label
                }}</li>
            </ul>
            <div>
              <span class="ViewMore contclass" v-if="menuActive == 1">
                <div :class="iconactive2 == 'table' ? 'svgbg svgclass' : 'svgclass'
                  ">
                  <svg t="1718592308727" v-if="iconactive2 == 'table'" class="icon" viewBox="0 0 1024 1024"
                    version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8137" width="2.2857rem" height="2.2857rem">
                    <path
                      d="M928 938.666667H96a53.393333 53.393333 0 0 1-53.333333-53.333334V181.333333a53.393333 53.393333 0 0 1 53.333333-53.333333h832a53.393333 53.393333 0 0 1 53.333333 53.333333v704a53.393333 53.393333 0 0 1-53.333333 53.333334z m-245.333333-42.666667h245.333333a10.666667 10.666667 0 0 0 10.666667-10.666667v-202.666666h-256z m-298.666667 0h256v-213.333333H384z m-298.666667-213.333333v202.666666a10.666667 10.666667 0 0 0 10.666667 10.666667h245.333333v-213.333333z m597.333334-42.666667h256V426.666667h-256z m-298.666667 0h256V426.666667H384z m-298.666667 0h256V426.666667H85.333333z m853.333334-256V181.333333a10.666667 10.666667 0 0 0-10.666667-10.666666H96a10.666667 10.666667 0 0 0-10.666667 10.666666v202.666667z"
                      fill="#1290C9" p-id="8138"></path>
                  </svg>

                  <svg t="1718592110652" v-else @click="clickIcon('table')" class="icon" viewBox="0 0 1024 1024"
                    version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7626" width="32" height="32">
                    <path
                      d="M928 938.666667H96a53.393333 53.393333 0 0 1-53.333333-53.333334V181.333333a53.393333 53.393333 0 0 1 53.333333-53.333333h832a53.393333 53.393333 0 0 1 53.333333 53.333333v704a53.393333 53.393333 0 0 1-53.333333 53.333334z m-245.333333-42.666667h245.333333a10.666667 10.666667 0 0 0 10.666667-10.666667v-202.666666h-256z m-298.666667 0h256v-213.333333H384z m-298.666667-213.333333v202.666666a10.666667 10.666667 0 0 0 10.666667 10.666667h245.333333v-213.333333z m597.333334-42.666667h256V426.666667h-256z m-298.666667 0h256V426.666667H384z m-298.666667 0h256V426.666667H85.333333z m853.333334-256V181.333333a10.666667 10.666667 0 0 0-10.666667-10.666666H96a10.666667 10.666667 0 0 0-10.666667 10.666666v202.666667z"
                      fill="#5C5C66" p-id="7627"></path>
                  </svg>
                </div>
                <div :class="iconactive2 == 'computer'
                  ? 'svgbg svgclass'
                  : 'svgclass'
                  ">
                  <svg t="1718592168330" v-if="iconactive2 == 'computer'" class="icon" viewBox="0 0 1214 1024"
                    version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7861" width="2.2857rem" height="2.2857rem">
                    <path
                      d="M94.734629 819.2c-52.0192 0-94.354286-40.872229-94.354286-91.077486V341.284571c0-13.312 11.190857-24.107886 24.9856-24.107885 13.780114 0 22.908343 10.795886 22.908343 24.107885v386.823315c0 23.639771 21.986743 44.675657 46.460343 44.675657h1018.953142c24.488229 0 47.030857-21.035886 47.030858-44.675657V93.037714c0-23.6544-22.528-43.695543-47.030858-43.695543H94.734629C70.261029 49.3568 48.274286 69.397943 48.274286 93.037714v107.373715c0 13.297371-9.128229 24.093257-22.908343 24.093257-13.794743 0-25.000229-10.795886-25.000229-24.107886V93.037714C0.365714 42.832457 42.715429 1.989486 94.734629 1.989486h1018.953142c52.0192 0 94.339657 40.842971 94.339658 91.077485v635.070172c0 50.205257-42.320457 91.077486-94.339658 91.077486H94.734629z"
                      fill="#1290C9" p-id="7862"></path>
                    <path
                      d="M704.2048 965.485714H855.771429c12.112457 0 21.694171 11.264 21.694171 23.376457 0 12.112457-9.581714 23.6544-21.694171 23.6544h-482.742858c-12.112457 0-22.191543-11.541943-22.191542-23.6544 0-12.127086 10.079086-23.376457 22.191542-23.376457h151.581258V819.2H570.514286v146.285714h87.771428V819.2h45.919086v146.285714zM177.678629 620.163657h44.426971V461.531429h-44.426971zM296.1408 620.163657h44.412343V389.412571h-44.412343zM429.407086 620.163657h44.412343V317.293714h-44.412343zM236.909714 187.4944c0 15.915886-13.268114 28.847543-29.608228 28.847543-16.384 0-29.622857-12.931657-29.622857-28.847543 0-15.945143 13.253486-28.847543 29.622857-28.847543 16.340114 0 29.608229 12.9024 29.608228 28.847543M325.749029 187.4944c0 15.915886-13.268114 28.847543-29.608229 28.847543s-29.608229-12.931657-29.608229-28.847543c0-15.945143 13.268114-28.847543 29.608229-28.847543s29.608229 12.9024 29.608229 28.847543M714.591086 420.322743h148.728685l112.347429-93.432686c-26.814171-30.939429-68.183771-52.077714-112.347429-52.077714-79.491657 0-146.666057 66.530743-148.728685 145.5104zM820.662857 568.188343l21.869714-113.2544h-126.098285c16.310857 53.642971 51.053714 91.399314 104.228571 113.2544z m174.474972-210.549029l-91.428572 77.297372 91.428572 54.535314C1004.251429 470.381714 1009.371429 446.800457 1009.371429 424.228571c0-23.2448-4.593371-47.074743-14.2336-66.589257zM877.714286 462.760229l-20.289829 110.270171c1.594514 0.043886 3.189029 0.073143 4.783543 0.073143 44.909714 0 87.815314-20.904229 114.644114-52.736L877.714286 462.760229zM863.085714 614.4c-105.033143 0-190.171429-85.138286-190.171428-190.171429s85.138286-190.171429 190.171428-190.171428 190.171429 85.138286 190.171429 190.171428-85.138286 190.171429-190.171429 190.171429z"
                      fill="#1290C9" p-id="7863"></path>
                  </svg>

                  <svg t="1718592454748" @click="clickIcon('computer')" v-else class="icon" viewBox="0 0 1214 1024"
                    version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8412" width="2.2857rem" height="2.2857rem">
                    <path
                      d="M94.734629 819.2c-52.0192 0-94.354286-40.872229-94.354286-91.077486V341.284571c0-13.312 11.190857-24.107886 24.9856-24.107885 13.780114 0 22.908343 10.795886 22.908343 24.107885v386.823315c0 23.639771 21.986743 44.675657 46.460343 44.675657h1018.953142c24.488229 0 47.030857-21.035886 47.030858-44.675657V93.037714c0-23.6544-22.528-43.695543-47.030858-43.695543H94.734629C70.261029 49.3568 48.274286 69.397943 48.274286 93.037714v107.373715c0 13.297371-9.128229 24.093257-22.908343 24.093257-13.794743 0-25.000229-10.795886-25.000229-24.107886V93.037714C0.365714 42.832457 42.715429 1.989486 94.734629 1.989486h1018.953142c52.0192 0 94.339657 40.842971 94.339658 91.077485v635.070172c0 50.205257-42.320457 91.077486-94.339658 91.077486H94.734629z"
                      fill="#000000" p-id="8413"></path>
                    <path
                      d="M704.2048 965.485714H855.771429c12.112457 0 21.694171 11.264 21.694171 23.376457 0 12.112457-9.581714 23.6544-21.694171 23.6544h-482.742858c-12.112457 0-22.191543-11.541943-22.191542-23.6544 0-12.127086 10.079086-23.376457 22.191542-23.376457h151.581258V819.2H570.514286v146.285714h87.771428V819.2h45.919086v146.285714zM177.678629 620.163657h44.426971V461.531429h-44.426971zM296.1408 620.163657h44.412343V389.412571h-44.412343zM429.407086 620.163657h44.412343V317.293714h-44.412343zM236.909714 187.4944c0 15.915886-13.268114 28.847543-29.608228 28.847543-16.384 0-29.622857-12.931657-29.622857-28.847543 0-15.945143 13.253486-28.847543 29.622857-28.847543 16.340114 0 29.608229 12.9024 29.608228 28.847543M325.749029 187.4944c0 15.915886-13.268114 28.847543-29.608229 28.847543s-29.608229-12.931657-29.608229-28.847543c0-15.945143 13.268114-28.847543 29.608229-28.847543s29.608229 12.9024 29.608229 28.847543M714.591086 420.322743h148.728685l112.347429-93.432686c-26.814171-30.939429-68.183771-52.077714-112.347429-52.077714-79.491657 0-146.666057 66.530743-148.728685 145.5104zM820.662857 568.188343l21.869714-113.2544h-126.098285c16.310857 53.642971 51.053714 91.399314 104.228571 113.2544z m174.474972-210.549029l-91.428572 77.297372 91.428572 54.535314C1004.251429 470.381714 1009.371429 446.800457 1009.371429 424.228571c0-23.2448-4.593371-47.074743-14.2336-66.589257zM877.714286 462.760229l-20.289829 110.270171c1.594514 0.043886 3.189029 0.073143 4.783543 0.073143 44.909714 0 87.815314-20.904229 114.644114-52.736L877.714286 462.760229zM863.085714 614.4c-105.033143 0-190.171429-85.138286-190.171428-190.171429s85.138286-190.171429 190.171428-190.171428 190.171429 85.138286 190.171429 190.171428-85.138286 190.171429-190.171429 190.171429z"
                      fill="#000000" p-id="8414"></path>
                  </svg>
                </div>
              </span>
            </div>
          </div>

        </div>
        <Alldate v-if="menuActive == 1 && iconactive2 == 'table'" :isOpenSlct="isOpenSlct"  :Compare="Compare" :FilterObj="FilterObj" ></Alldate>
        <AlldateEchats v-if="menuActive == 1 && iconactive2 == 'computer'" :isOpenSlct="isOpenSlct" :Compare="Compare" ></AlldateEchats>
        <Companiesviewed v-if="menuActive == 2" :isOpenSlct="isOpenSlct" refs="Companiesviewed" :Compare="Compare" ></Companiesviewed>
        <companiesCollected v-if="menuActive == 3" :isOpenSlct="isOpenSlct" :Compare="Compare"  refs="companiesCollected">
        </companiesCollected>
        <CompaniesUploaded v-if="menuActive == 4" :isOpenSlct="isOpenSlct" :Compare="Compare" ></CompaniesUploaded>
        <myPortfolio v-if="menuActive == 5"></myPortfolio>
      </div>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import ReLogin from "../../../components/ReLogin.vue";
import Page from '@/components/page/index.vue';
import Alldate from "./components/Alldate.vue";
import Companiesviewed from "./components/Companiesviewed.vue";
import companiesCollected from "./components/companiesCollected.vue";
import CompaniesUploaded from "./components/CompaniesUploaded.vue";
import myPortfolio from "./components/myPortfolio.vue";
import AlldateEchats from "./components/AlldateEchats.vue";
import { getTabListOneLayerForAccount } from "@/api/companyApi";
export default {
  mixins: [mixins1],
  components: {
    ReLogin,
    Page,
    Alldate,
    Companiesviewed,
    companiesCollected,
    CompaniesUploaded,
    myPortfolio,
    AlldateEchats
  },
  watch:{
  FilterObj: {
            handler(newVal, oldVal) {
                // 在这里处理columns属性的变化
              this.FilterObj=newVal
                // 这里可以进行一些逻辑处理或者触发其他操作
            },
            powerArr:[],
            deep: true, // 深度监听，可以监听对象内部属性的变化
            immediate: true, // 立即执行一次handler函数，即使columns没有变化
        },
  },
  data() {
    return {
      reLoginVis: false,
      isOpenSlct: false,
      Compare:false,
      FilterObj:{
        companyIsicEn:'',
        companyName:'',
        companyStatusEn:'',
        companyTypeEn:"",
        endTime:'',
        startTime:'',
      },
      iconactive2: 'table',
      menuActive: 1,

      window: window,
    
      managementMenu: [
        {
          label: 'All Companies',
          value: '1'
        },
        {
          label: 'Companies Viewed',
          value: '2'
        },
        {
          label: 'Companies Collected',
          value: '3'
        },
        {
          label: 'Companies Uploaded',
          value: '4'
        },
        {
          label: 'My Portfolio',
          value: '5'
        },
      ]
    };
  },
  beforeDestroy() { },
  destroyed() { },
  mounted() {
    this.getTabListOneLayerForAccountlist()
    if (this.$route.query.type) {
      this.menuActive = this.$route.query.type
    }
    if(this.$route.query.type!=1){
           this.$store.dispatch("app/setTools", {

                name: "menu",
                key: "isActive",
                value: false,
            });
    }else{
        this.$store.dispatch("app/setTools", {

                name: "menu",
                key: "isActive",
                value: true,
            });
    }
  },

  methods: {
     setToolsfalse() {
      this.$store.dispatch("app/setTools", {

        name: "menu",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {

        name: "select",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {

        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "riskScanning",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "creditAssessment",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "dataAnalysis",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "customPortfolio",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "print",
        key: "isActive",
        value: false,
      });
    },
    getTabListOneLayerForAccountlist(){
      getTabListOneLayerForAccount({
        moduleId:507
      }).then(res=>{
        if(res.code==200){
          this.powerArr=res.data
        }
      })
    },
    clickIcon(value) {

      if( this.powerArr[1].hasPrivilege){
  
      if(value=='table'){
   this.$store.dispatch("app/setTools", {

                name: "menu",
                key: "isActive",
                value: true,
            });
          this.$store.dispatch("app/toggleMenu", false);
      }else{
         this.$store.dispatch("app/setTools", {

                name: "menu",
                key: "isActive",
                value: false,
            });
                 this.$store.dispatch("app/setTools", {
                name: "riskScanning",
                key: "isActive",
                value: false,
            });
                this.$store.dispatch("app/setTools", {
                name: "customPortfolio",
                key: "isActive",
                value: false,
            });
                this.$store.dispatch("app/setTools", {
                name: "share",
                key: "isActive",
                value: false,
            });
          this.$store.dispatch("app/toggleMenu", true);
      }
          this.iconactive2 = value
      

      }else{
      this.$bus.$emit('show-permission-dialog', '您没有权限访问该功能！');

      }

    },
    MenuClick(item) {
      if(item.value<=3 || this.powerArr[5].hasPrivilege){
              if(item.value==1){
         this.iconactive2 = 'table'
       this.$store.dispatch("app/setTools", {

                name: "menu",
                key: "isActive",
                value: true,
            });
      }else{
          
            this.$store.dispatch("app/setTools", {
                name: "menu",
                key: "isActive",
                value: false,
            });
                this.$store.dispatch("app/toggleMenu", true);
      }
      this.menuActive = item.value
      this.$router.push({
        query: {

          type: item.value       // 修改或添加type参数
        }
      })


      }else{
        this.$bus.$emit('show-permission-dialog', '您没有权限访问该功能！');

      }
     
            this.$store.dispatch("app/setcollectList", []);
            this.$store.dispatch("app/setchangeList", []);   
              this.$store.dispatch("app/setTools", {
                name: "riskScanning",
                key: "isActive",
                value: false,
            });
                this.$store.dispatch("app/setTools", {
                name: "customPortfolio",
                key: "isActive",
                value: false,
            });
                this.$store.dispatch("app/setTools", {
                name: "share",
                key: "isActive",
                value: false,
            });

    },





  },
};
</script>
<style scoped>
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.form-email {
  display: flex;
  width: 100%;
}

.block-con-body-text {
  word-break: keep-all;
  text-align: justify;
  font-size: 1rem;
  color: #022955;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.item_txtcolor1 {
  color: #1290c9;
}

.item_txtcolor2 {
  color: #55b419;
}

.item_txtcolor3 {
  color: #ffa000;
}

.das_top_item .color1 {
  background: rgba(18, 144, 201, 0.12);
}

.das_top_item .color2 {
  background: rgba(85, 180, 25, 0.12);
}

.das_top_item .color3 {
  background: rgba(255, 160, 0, 0.12);
}

.das_top_item .color4 {
  background: #ff7600;
}

.das_top_item .item_img img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
}

.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: left;
}

.das_top_item .item_group {
  margin-left: 0.7142857142857143rem;
  font-size: 1.2857142857142858rem;

  /* width: 17.142857142857142rem; */
}

.das_top_item .item_lab {
  display: block;
  color: #1a2332;

  margin-top: 0.35714285714285715rem;
}

.item_txt {
  font-size: 1.857142857143rem;
  text-align: center;
}

.cont_m {
  margin-top: 2.142857142857143rem;
  margin-bottom: 5.714285714285714rem;
}

.country_box {
  margin-top: 4.285714285714286rem;
}

.country_box .title {
  margin-bottom: 0;
}

.title {
  margin-bottom: 1.4285714285714286rem;
}

.title_txt {
  font-size: 1.1428571428571428rem;
  font-family: 'DMSans Bold';
}

.title_txt img {
  width: 1.4285714285714286rem;
  margin-right: 0.5714285714285714rem;
}

.c_d_buttom {
  justify-content: flex-end;
  /* margin-top: 1.4285714285714286rem; */
  margin-bottom: 0;
}

.btn_blue {
  padding: 0.7142857142857143rem 1.4285714285714286rem;
  background: #1290c9;
  font-size: 1.2857142857142858rem;
  color: #ffffff;
  cursor: pointer;
}

.btn_blu {
  margin-right: 1.4285714285714286rem;
}

.btn_blue img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
  margin-right: 0.42857142857142855rem;
}

.sel_box /deep/ .el-input__inner {
  border-color: #ccc;
  border-radius: 0.5714285714285714rem;
  font-size: 1.1428571428571428rem;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.das_top_item {
  width: 32.5%;
  padding: 1.4285714285714286rem;
  /* border-radius: 1rem; */
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0rem 0.14285714285714285rem 0.2857142857142857rem 0rem rgba(0, 0, 0, 0.12);
}

.das_top_item .item_img {
  width: 4.285714285714286rem;
  height: 4.285714285714286rem;
  line-height: 5.571428571428571rem;
  text-align: center;
  border-radius: 50%;
}

.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: center;
}

.top_tab {
  margin-top: 2.857142857142857rem;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}

.jiange {
  color: #cccccc;
  margin: 0 1.4285714285714286rem;
  font-size: 1.285714285714286rem;
  /* font-size: 1.25em; */
}

.contclass {
  font-size: 1.285714285714286rem;
  color: #1290c9;
  font-style: normal;
}

/deep/ .el-table th.el-table__cell>.cell {
  font-family: 'DMSans Bold';
}

.last-colmun {
  padding: 2rem 0rem;
  border-bottom: 0.07142857142857142rem solid #ebeef5;
}

.dingwei {
  position: absolute;
  top: -2.142857142857143rem;
  right: 0rem;
}

/deep/ .el-descriptions-item__cell {
  padding-bottom: 2.142857142857143rem !important;
}

/deep/ .avatar-uploader .el-upload {
  border: 0.07142857142857142rem dashed #d9d9d9;
  border-radius: 0.42857142857142855rem;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

/deep/ .avatar-uploader-icon {
  font-size: 1.4285714285714286rem;
  color: #8c939d;
  width: 5rem;
  height: 5rem;
  line-height: 5rem;
  text-align: center;
}

/deep/ .avatar {
  width: 5rem;
  height: 5rem;
  display: block;
}

/* 日历大小 */
.el-range-editor.el-input__inner {
  /* width: 16rem !important; */
  padding: 0.21428571428571427rem 0.21428571428571427rem;
}

.el-date-editor /deep/ .el-range__icon {
  font-size: 1.1428571428571428rem;
  margin-left: -0.35714285714285715rem;
  color: #1A2332;
  /* float: left; */
  line-height: 2.2857142857142856rem;
  position: relative;
  left: 47%;
}

@media screen and (max-width: 1441px) {
  .btn_blue {
    font-size: 14px;
    width: max-content;
  }
}

.Data-Management-ul {
  padding: 5px 20px;
  background: #F5F5F5;
  border-radius: 4px;
  width: max-content;
  margin: auto;

}

.Data-Management-ul li {
  padding: 10px 20px;
  cursor: pointer;
}

.menuActiveColor {
  background: #FFFFFF;
  border-radius: 4px;
}

.svgbg {
  background-color: #ffffff;
}

.svgclass {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  height: 3.142857142857143rem;
  border-radius: 1.5714285714285714rem;
}

.ViewMore {
  line-height: 1.8571428571428572rem;
  text-align: left;
  font-style: normal;
  text-decoration-line: underline;
  margin-left: 2.142857142857143rem;
}

.contclass {
  font-size: 1.4285714285714286rem;
  color: #1290c9;
  font-style: normal;
  height: 3.5714285714285716rem;
  background: #f5f5f5;
  border-radius: 1.7857142857142858rem;
  display: flex;
  align-items: center;
  padding: 0.21428571428571427rem;
}

.icon {
  margin: 0 1.4285714285714286rem;
}
</style>